module.exports = __webpack_public_path__ + "img/default-logo.9231bb13.png";